export default __webpack_public_path__ + "static/media/arrow-big-top.6458e290.svg";